const AncillariesLoaderBase = require('./loader.base');
const data = require('./loader.debug.data');

class DebugAncillariesLoader extends AncillariesLoaderBase {
    load() {
        this.onDataReceived(data);
    }
}

module.exports = DebugAncillariesLoader;
